import React from 'react';
import BaseList from '@its/components/lib/Container components/ListContainer/BaseList';
import {
  getDisplayList,
  handleTemplateList,
  handleTimerList,
  handleDepartmentList,
  displayListAppBar,
} from './util';
import {
  setDisplays,
  setDisplayList,
} from '../../redux/display/actions';
// import FontIcon from 'material-ui/FontIcon';
import {
  getDisplays,
  getTemplates,
  getTimers,
  getDepartments,
} from '../../api';

export default class extends React.Component {

  static propTypes = {
    navigate: React.PropTypes.bool,
    buttonStyle: React.PropTypes.object,
  }

  static defaultProps = {
    navigate: true,
    buttonStyle: {},
  }

  constructor(props, context) {
    super(props, context);
    this.mapStateToProps = (state) => ({
      title: state.app.displays.list.title,
      currentFilter: state.app.displays.list.currentFilter,
      columns: state.app.displays.list.columns,
      items: state.app.displays.list.items,
    });
  }

  onSuccess(data, dispatch, props) {
    dispatch(setDisplays(data[0].body.resultSet));
    dispatch(setDisplayList(getDisplayList(dispatch, data[0].body.resultSet, props)));
    handleTemplateList(data[1], dispatch);
    handleTimerList(data[2], dispatch);
    handleDepartmentList(data[3], dispatch);
  }

  render() {
    return (
      <BaseList
        route="display/add"
        mapStateToProps={this.mapStateToProps}
        appBar={displayListAppBar}
        request={[getDisplays, getTemplates, getTimers, getDepartments]}
        onResult={this.onSuccess}
        buttonStyle={this.props.buttonStyle}
        navigate={this.props.navigate}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/DisplayList.js
 **/